'use client'

import { useState } from 'react'

export function useProductQuantity({ variant, initial = 1 }: { variant?: any; initial?: number } = {}) {
  const [quantity, setQuantity] = useState<number | ''>(initial)

  // A different variant may have less stock; apply the same cap as handleBlur.
  const [prevVariantId, setPrevVariantId] = useState(variant?.id)
  if (prevVariantId !== variant?.id) {
    setPrevVariantId(variant?.id)
    if (typeof quantity === 'number' && variant?.stock && quantity > variant.stock) setQuantity(variant.stock)
  }

  const handleChange = (value: string) => {
    if (value === '') {
      setQuantity('')
      return
    }
    const parsed = parseInt(value, 10)
    if (!isNaN(parsed)) setQuantity(parsed)
  }

  const handleBlur = () => {
    if (quantity === '' || (typeof quantity === 'number' && quantity < 1)) {
      setQuantity(1)
    } else if (typeof quantity === 'number' && variant?.stock && quantity > variant.stock) {
      setQuantity(variant.stock)
    }
  }

  return { quantity, setQuantity, handleChange, handleBlur }
}
